import React from 'react';
import { Link } from '../../../env';
const Navbar = () => {
    const SocialMediaIcon = [
        {
            img: `${Link}assets/SocialMedia/instagram.png`,
            label: 'Instagram'
        },
        {
            img: `${Link}assets/SocialMedia/linkedin.png`,
            label: 'LinkedIn'
        },
        {
            img: `${Link}assets/SocialMedia/telegram.png`,
            label: 'Telegram'
        },
    ]
    return (
        <div className="w-full h-[70px] bg-[#2c3e50] flex justify-center">
            <div className='container'>
                <div className='w-full h-full flex justify-between items-center'>
                    <div className='h-full flex items-center px-10'>
                        <span className='poppins-medium text-white text-xl'>IRSystem</span>
                        <span className='poppins-medium text-[#fffb00] text-xl'>Tuning</span>
                    </div>
                    <div className='h-full flex items-center px-10'>
                        {
                            SocialMediaIcon.map((item, index) => {
                                return (
                                    <>
                                        <div><img src={item.img} className='w-[30px] cursor-pointer mx-2' /></div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
